var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.304 48.768a2.433 2.433 0 01-.72 1.584C4.152 50.784 3.624 51 3 51c-.672 0-1.224-.192-1.656-.576-.384-.432-.576-.984-.576-1.656V2.832c0-.672.216-1.2.648-1.584C1.848.816 2.4.6 3.072.6c.624 0 1.152.216 1.584.648.432.432.648.96.648 1.584v45.936z",
    fill: "currentColor"
  })));
}
export default SvgI;